var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"newsList"}},[_c('ul',_vm._l((_vm.dataList),function(item,i){return _c('li',{key:i,on:{"click":function($event){_vm.$router.push({path: '/newsDetail', query: {id: item.id}})}}},[_c('img',{attrs:{"src":item.img,"alt":""}}),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.date))])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efa9b362","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newsList.vue
// module id = null
// module chunks = 